import React, { Fragment, useEffect, useState } from 'react'
import Header from '../components/layouts/Header'
import Footer from '../components/layouts/Footer'
import DeveloperProfile from '../features/developer/DeveloperProfile'
import DeveloperDetails from '../features/developer/DeveloperDetails'
import SimplifySection from '../features/developer/SimplifySection'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { fetchDeveloperDetail } from '../redux/action/commonAction'
import { setDeveloperDetail, setDeveloperLoading } from '../redux/slice/commonSlice'
import RegistrationCardForm from '../features/common/RegistrationCardForm'
import Modal from '../components/general/Modal'
import { setShowSuccessModal } from '../redux/slice/commonSlice'
import SuccessModal from '../features/findJobs/SuccessModal'
import useCanonical from '../hooks/useCanonical'

const DeveloperDetailsPage = () => {
    const dispatch = useDispatch()
    const { slug } = useParams();
    const { developer: { isLoading }, showSuccessModal } = useSelector(state => state.common);
    const [isRegistrationModalOpen, setIsRegistrationModalOpen] = useState(false);
    const canonicalTag = useCanonical(`/developer/${slug}`);

    useEffect(() => {
        if (slug && !isLoading) dispatch(setDeveloperLoading(true))
    }, [slug])

    useEffect(() => {
        if (!isLoading) return;
        if (slug) dispatch(fetchDeveloperDetail(slug))
    }, [slug, isLoading])

    useEffect(() => {
        return () => dispatch(setDeveloperDetail({}))
    }, [])

    const handleSuccessModalClose = () => {
        dispatch(setShowSuccessModal(false));
    }

    return (
        <Fragment>
            {canonicalTag}
            <Header />
            <main className="bg-black">
                <div className="lg:flex lg:justify-between max-width">
                    <div className='lg:sticky lg:top-[68px] lg:h-[100vh] lg:w-[35%] lg:overflow-y-auto bg-black'>
                        <DeveloperProfile 
                            onUnlockRatesClick={() => setIsRegistrationModalOpen(true)}
                        />
                    </div>
                    <div className='lg:w-[65%]'>
                        <DeveloperDetails onUnlockRatesClick={() => setIsRegistrationModalOpen(true)} />
                    </div>
                </div>
                <SimplifySection />
            </main>

            <Modal show={isRegistrationModalOpen} onClose={() => setIsRegistrationModalOpen(false)} containerClasses="rounded-[10px] lg:w-[30%]">
                <RegistrationCardForm name='Unknown (From Developer Profile)' onSucess={() => setIsRegistrationModalOpen(false)} developerPageURL={window.location.href}/>
            </Modal>

            <SuccessModal show={showSuccessModal} onClose={handleSuccessModalClose} />

            <Footer />
        </Fragment>
    )
}

export default DeveloperDetailsPage